import React from 'react';

import IndexFilterChips from '@buyside/components/presentation/IndexFilterChips/IndexFilterChips';
import JobApplicationIndexPageFilter from '@buyside/components/presentation/JobApplicationIndexPage/StickyFilter/Filter/JobApplicationIndexPageFilter';
import StickyHeader from '@buyside/components/presentation/StickyHeader/stickyHeader';

const ideaStickyFilterStyles = require('buyside/components/presentation/IndexPageHeader/Filters/stickyFilterStyles.scss');

const JobApplicationIndexPageStickyFilter: React.FC = () => {
  return (
    <StickyHeader>
      {({ isSticky }: { isSticky: boolean }): React.ReactElement => (
        <div className={ideaStickyFilterStyles.wrapper}>
          <div className={isSticky ? ideaStickyFilterStyles.container : ''}>
            {isSticky ? (
              <h3 className={ideaStickyFilterStyles.filterTitleContainer}>Filters</h3>
            ) : null}
            <div>
              <IndexFilterChips />

              <div>
                <JobApplicationIndexPageFilter />
              </div>
            </div>
          </div>
        </div>
      )}
    </StickyHeader>
  );
};

export default JobApplicationIndexPageStickyFilter;
